import { lowerFirst } from './string';
/**
 * @param {string} prefix
 * @param {string} value
 */

var unprefixPropName = function unprefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
};

export default unprefixPropName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/unprefix-prop-name.js
// module id = 816
// module chunks = 0